import { fetcher } from '@commenda/utils';

export async function clearIndirectTaxExposure(
  corporationId: number
): Promise<{ success: boolean; message?: string; error?: string }> {
  try {
    const response = await fetcher(
      `new-sales-tax/exposure/clear?corporationId=${corporationId}`,
      { method: 'DELETE' }
    );

    if (!response.ok) {
      const errorData = await response.json();
      return {
        success: false,
        error: errorData?.message ?? response.statusText,
      };
    }

    const json = await response.json();
    return { success: true, message: json.message };
  } catch (error: unknown) {
    return {
      success: false,
      error:
        error instanceof Error ? error.message : 'Failed to clear exposure',
    };
  }
}
